// API URL configuration
// In production (Vercel), uses empty string for relative URLs through Vercel proxy
// In development, uses localhost or VITE_API_URL environment variable

export const API_BASE_URL = import.meta.env.PROD
  ? ''
  : (import.meta.env.VITE_API_URL || import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000');
